import { useAuth } from "api/hooks/useAuth";
import { deleteAccount } from "api/user";
import { t } from "i18next";
import { notifySimple } from "providers/toast";
import { shallowEqual, useSelector } from "react-redux";
import { userInformation } from "store/user/userSelectors";
import ProfileCard from "widgets/cards/profile";
import GenericButton from "widgets/controls/buttons/generic";
import { useNotificationDialog } from "providers/notification-dialog-provider";

const Delete = () => {
  const auth = useAuth();
  const userInfo = useSelector(userInformation, shallowEqual);

  const { notify } = useNotificationDialog();

  const doDelete = async () => {
    const { status } = await deleteAccount(userInfo.email);

    if (status && status === 200) {
      auth.deleteUser();
    } else {
      notifySimple("Failed to delete Account", "error");
    }
  };

  return (
    <>
      <ProfileCard
        title={t("profile.delete.account.title")}
        description={t("profile.delete.account.description")}
        bgColor="bg-background-200"
        textColor="text-white"
        textDescriptionColor="text-white"
        extra="h-full"
      >
        <div className="flex h-full w-full flex-col">
          <div className="flex-grow"></div>
          <div className="flex justify-end">
            <GenericButton
              variant="outline"
              size="md"
              text={t("button.action.delete")}
              onClick={() => {
                notify({
                  header: t("dialog.warning.title"),
                  message: t("profile.delete.account.warning"),
                  okText: t("button.action.delete"),
                  cancelText: t("button.action.cancel"),
                  onOk: doDelete,
                  onCancel: () => {},
                });
              }}
              color="white"
            />
          </div>
        </div>
      </ProfileCard>
    </>
  );
};

export default Delete;
